<template>
    <div>
        <div class="roleManagement-title">{{ $t('permission_configuration_management.role.roleManagement') }}</div>
        <div class="roleManagement-top">
            <role-management-search></role-management-search>
        </div>
        <table-role-management></table-role-management>
    </div>
</template>

<script>
    import RoleManagementSearch from '../role_management/RoleManagementSearch'
    import TableRoleManagement from '../role_management/TableRoleManagement'
    export default {
        name: 'RoleManagement',
        components: {
            RoleManagementSearch,
            TableRoleManagement
        }
    }
</script>

<style scoped>
    .roleManagement-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .roleManagement-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/role_management/RoleManagement.vue